import React from 'react';
import {
  PageHeader,
  Heading,
  Page,
  PageContent,
  Box,
  Text,
  Grid,
  ResponsiveContext,
} from 'grommet';
import { DashboardGrid } from '../../components/DashboardGrid';
import { HomeGlobe3D } from './HomeGlobe3D';
import HomeTilesCSV from '../../data/home/HomeTiles.csv';

export const HomeTest = () => {
  const size = React.useContext(ResponsiveContext);

  // Define layout areas based on screen size
  const isSmall = size === 'xsmall' || size === 'small';
  const gridAreas = isSmall
    ? [
        ['dashboard'],
        ['globe'],
      ]
    : [['dashboard', 'globe']];

  const columns = isSmall ? ['flex'] : ['3/3', '1/3'];

  return (
    <Page flex="grow" background="background" style={{ overflowX: 'hidden' }}>
      {/* Header Section */}
      <Box
        background="url('/images/hpe-hq-lobby.jpg')"
        height={{ min: '140px' }}
        pad={{ bottom: 'small' }}
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <Box margin={{ left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={
              <Text color="white" size="xxlarge" weight="bolder">
                HPE OneGW
              </Text>
            }
            subtitle="Our intelligent GlobalWorkplace Platform"
            style={{ color: 'white' }}
            size="medium"
          />
        </Box>
      </Box>

      {/* Main Content */}
      <PageContent flex="grow" style={{ overflowX: 'hidden' }}>
        <Heading size="small" weight="bold" margin={{ bottom: 'none' }} pad="none">
          Spotlight:
        </Heading>
        <Grid
          areas={gridAreas}
          columns={columns}
          rows={['auto']}
          gap="medium"
          pad="medium"
          margin={{ top: 'none' }}
          responsive
        >
          <Box gridArea="dashboard" fill>
            <DashboardGrid filePath={HomeTilesCSV} />
          </Box>
          <Box gridArea="globe" fill>
            <HomeGlobe3D />
          </Box>
        </Grid>
      </PageContent>
    </Page>
  );
};


